import { createContext } from 'react';
import { Tenant } from '@/services/tenant';

export interface AdminTenantContextValue {
  // 租户列表
  tenants: Tenant[];
  // 默认租户
  defaultTenant: Tenant | null;
  // 默认租户ID (快捷访问)
  defaultTenantId: string | null;
  // 加载状态
  isLoading: boolean;
  // 是否已初始化
  isInitialized: boolean;
  // 错误信息
  error: string | null;
  // 刷新租户列表
  refresh: () => Promise<void>;
  // 根据ID获取租户
  getTenantById: (id: string) => Tenant | undefined;
}

export const AdminTenantContext = createContext<AdminTenantContextValue | null>(
  null
);
